import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import SidebarNav from "./SidebarNav";
import SidebarFooter from "./SidebarFooter";
import Stack from "../ui/Stack";
import Button from "../common/button/Button";
import {changeShowMenu} from "../../store/utility-slice";
import Icon from "../ui/Icon";
import SidebarLogo from "./SidebarLogo";

const Sidebar = () => {
    const showMenu = useSelector(state => state.utility.showMenu);
    const dispatch = useDispatch();


    return (<>
        <aside
            className={`sidebar${showMenu ? " show" : ''} d-flex flex-column bg-white min-vh-100 p-5 vh-100 overflow-auto position-sticky top-0`}>
            <Button className="mb-2 ms-auto menu-close rounded-pill d-block d-md-none bg-primary bg-opacity-10 p-1" onClick={()=>dispatch(changeShowMenu())}>
                <Icon name="cross" width="24px" fill="gray"/>
            </Button>
            <SidebarLogo/>
            <Stack className="flex-grow-1">
                <SidebarNav/>
            </Stack>
            <SidebarFooter/>
        </aside>
    </>)
};

export default Sidebar;
